import {
    combineReducers
} from 'redux';

import countryReducer from './countryReducer';
import assessmentReducer from './assessmentReducer';
import pollReducer from './pollReducer';
import appTypeReducer from './appTypeReducer';

const appReducer = combineReducers({
    countryInfo: countryReducer,
    assessment: assessmentReducer,
    poll: pollReducer,
    appType: appTypeReducer
});

export default appReducer;